import * as React from "react";

function SvgSalesOutlined(props) {
  return <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M21.358.25L1.388 20.22a4.139 4.139 0 00-1.221 2.947c0 1.112.433 2.158 1.22 2.946l12.5 12.5a4.139 4.139 0 002.946 1.22 4.138 4.138 0 002.946-1.22l19.97-19.971V.25H21.359zm1.725 4.167h12.5v12.5l-18.75 18.75-12.5-12.5 18.75-18.75zm6.25 4.166a2.083 2.083 0 100 4.167 2.083 2.083 0 000-4.167z" /></svg>;
}

export default SvgSalesOutlined;